export const statuses = {
  open: 'Aberto',
  canceled: 'Cancelado',
  closed: 'Fechado',
};

export function getName(value) {
  return statuses[value];
}
